import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = ['Home', 'Services', 'About', 'FAQ', 'Reviews', 'Contact'];
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm" style={{
    maxHeight: isOpen ? 'none' : undefined
  }} data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="flex items-center justify-between h-16" data-id="element-90">
          {/* Logo */}
          <a href="#" className="flex items-center gap-1 flex-shrink-0" data-id="element-91">
            <span className="font-bold text-xl" style={{
            color: '#1B2A4A'
          }} data-id="element-92">
              Precise Transcripts
            </span>
            <span className="font-bold text-xl" style={{
            color: '#C8962E'
          }} data-id="element-93">
              LLC
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation" data-id="element-94">
            {navLinks.map(link => <a key={link} href="#" className="text-sm font-medium transition-colors duration-200" style={{
            color: '#1E1E1E'
          }} onMouseEnter={e => e.currentTarget.style.color = '#2DA5A0'} onMouseLeave={e => e.currentTarget.style.color = '#1E1E1E'} data-id="element-95">
                {link}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center" data-id="element-96">
            <a href="#" className="text-sm font-semibold text-white rounded-lg px-5 py-2 transition-opacity hover:opacity-90" style={{
            backgroundColor: '#2DA5A0'
          }} data-id="element-97">
              Get a Quote
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button className="lg:hidden p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset" style={{
          color: '#1B2A4A'
        }} onClick={() => setIsOpen(!isOpen)} aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen} data-id="element-98">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-99" /> : <MenuIcon className="w-6 h-6" data-id="element-100" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="lg:hidden bg-white border-t border-gray-100 px-4 pb-6 pt-4" data-id="element-101">
          <nav className="flex flex-col gap-1" aria-label="Mobile navigation" data-id="element-102">
            {navLinks.map(link => <a key={link} href="#" className="block py-3 px-2 text-sm font-medium rounded-md transition-colors" style={{
          color: '#1E1E1E'
        }} onClick={() => setIsOpen(false)} onMouseEnter={e => e.currentTarget.style.color = '#2DA5A0'} onMouseLeave={e => e.currentTarget.style.color = '#1E1E1E'} data-id="element-103">
                {link}
              </a>)}
            <a href="#" className="mt-3 text-center text-sm font-semibold text-white rounded-lg px-5 py-3 min-h-[48px] flex items-center justify-center transition-opacity hover:opacity-90" style={{
          backgroundColor: '#2DA5A0'
        }} onClick={() => setIsOpen(false)} data-id="element-104">
              Get a Quote
            </a>
          </nav>
        </div>}
    </header>;
}